import * as H from 'history';
import  React from 'react';
import { ClaimController } from '../../../../controllers/ClaimController';
import { ClaimModel } from '../../../../models/ClaimModel';
import { Representation } from '../../../../models/Representation';
import { ISupportSpinner } from '../../../../shared/Ajax';
import { Backdrop } from '../../../../shared/Backdrop';
import { Option } from '../../../../shared/fields/Options';
import { newGuid, ScheduleTypes } from '../../../../shared/Utility';
import { SaveCancelButtons } from '../../controls/SaveCancelButtons';
import { ScheduleInstructions } from '../../controls/ScheduleInstructions';
import { RepresentationDetails } from './RepresentationDetails';



export interface RepresentationPageProps {
    history: H.History
    model: ClaimModel
    item: string
    markets: Option<string>[]
    onChange: { (changes: Partial<ClaimModel>, callback?: { (): any }): any }
    addressCountries: Option<string>[]
}

export interface RepresentationPageState {
    loading: boolean
    model: Representation
    existing: boolean
}

export class RepresentationPage extends React.Component<RepresentationPageProps, RepresentationPageState> implements ISupportSpinner {
    ajax: ClaimController
    details: RepresentationDetails

    constructor(props: RepresentationPageProps) {
        super(props);

        this.ajax = new ClaimController();

        this.state = this.getState(props);
    }

    componentDidUpdate(prevProps: RepresentationPageProps, prevState: RepresentationPageState) {
        if (this.props.item != prevProps.item) {
            this.setState(this.getState(this.props))
        }
    }


    componentWillUnmount() {
        this.ajax.cancel();
    }

    toggleSpinner(on: boolean, callback: { (): any }): void {
        this.setState({ loading: on }, callback);
    }


    getState(props: RepresentationPageProps): RepresentationPageState {
        let model: Representation;

        let match = props.model.representations.filter(r => r.id == props.item);
        if (match.length > 0)
            model = JSON.parse(JSON.stringify(match[0]));
        else
            model = {
                id: newGuid(),
                title: null,
                firstName: '',
                lastName: '',
                phone: '',
                mobile: '',
                email: '',
                website: '',
                registeredName: '',
                tradingName: '',
                physicalAddress: null,
                postalAddressDifferent: null,
                postalAddress: null,
                claimedBefore: null,
                relationship: '',
                description: '',
                entries: [],
                representedFrom: null,
                representedTo: null
            }

        return {
            loading: false,
            model: model,
            existing: match.length > 0
        };
    }

    remove = () => {
        if (confirm("Remove this representative?")) {
            let representations = this.props.model.representations.filter(r => r.id != this.state.model.id);
            this.props.onChange({ representations }, () => {
                this.ajax.updateSchedules(this, this.props.model, ScheduleTypes.OverseasRepresentative, () => {
                    this.props.history.goBack();
                })
            });
        }
    }

    save = () => {
        this.details.validate(res => {
            if (res) {
                this.details.table.saveAndClose(res => {
                    if (res) {
                        if (this.state.model.entries.filter(r => r.invalid).length == 0) {
                            let representations = this.props.model.representations.slice();
                            let replaceAt = 0;
                            for (; replaceAt < representations.length; replaceAt++) {
                                if (representations[replaceAt].id == this.state.model.id) {
                                    break;
                                }
                            }
                            if (replaceAt < representations.length) {
                                representations.splice(replaceAt, 1, this.state.model);
                            }
                            else {
                                representations.push(this.state.model);
                            }

                            this.props.onChange({ representations }, () => {
                                this.ajax.updateSchedules(this, this.props.model, ScheduleTypes.OverseasRepresentative, () => {
                                    this.props.history.goBack();
                                })
                            });
                        }
                        else {
                            alert("Please correct records marked with the warning sign.");
                        }
                    }
                });
            }
        });
    }

    render() {        
        return <>
            <SaveCancelButtons onCancel={this.props.history.goBack} onRemove={this.state.existing ? this.remove : null} onSave={this.save} />

            <ScheduleInstructions
                title="Overseas representative"
                hideApportionmentNote={true}
                helpLink="https://www.austrade.gov.au/ArticleDocuments/6917/Guide-to-Schedule-1A.pdf.aspx" />

            <RepresentationDetails ref={r => this.details = r}
                id="representation"
                model={this.state.model}
                onChange={c => this.setState({ model: { ...this.state.model, ...c } })}
                claim={this.props.model}
                addressCountries={this.props.addressCountries}
                markets={this.props.markets}
            />

            <SaveCancelButtons onCancel={this.props.history.goBack} onRemove={this.state.existing ? this.remove : null} onSave={this.save} />

            <Backdrop on={this.state.loading} />
        </>
    }
}